module.exports = __webpack_public_path__ + "img/logoESGIntezmeny.5b64e91a.png";